import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const STUDIES = [{
  company: 'Acme Corp',
  logo: 'A',
  metric: '40% faster',
  result: 'response times to inbound enterprise leads.',
  quote: '"Giga feels like having three extra SDRs who never sleep. It handles the initial research and drafting perfectly."',
  image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&q=80&w=800'
}, {
  company: 'Northwind',
  logo: 'N',
  metric: '12 hours',
  result: 'saved per week per engineer on status updates.',
  quote: '"We wired Giga to GitHub and Jira. Now nobody writes standup notes — Giga just drops a perfect summary in Slack every morning."',
  image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800'
}, {
  company: 'Globex',
  logo: 'G',
  metric: '3x increase',
  result: 'in successful customer onboarding completions.',
  quote: '"It monitors product usage events and proactively reaches out to customers who are stuck. It\'s completely changed our retention curve."',
  image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80&w=800'
}, {
  company: 'Initech',
  logo: 'I',
  metric: 'Zero',
  result: 'missed SLA breaches in the last 6 months.',
  quote: '"Giga watches our support queues and escalates critical issues before they breach. It\'s our ultimate safety net."',
  image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&q=80&w=800'
}];
export function CaseStudies() {
  return <div className="min-h-screen bg-[#FAF8F4] pt-32 pb-24" data-id="element-2637">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10" data-id="element-2638">
        {/* Header */}
        <div className="max-w-2xl mb-16 md:mb-24" data-id="element-2639">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-sm font-bold tracking-widest uppercase text-[#EA580C] mb-4 block" data-id="element-2640">
            Case Studies
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-6xl font-title font-bold text-[#2B211A] mb-6 tracking-tight leading-[1.1]" data-id="element-2641">
            How the best teams use Giga.
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-lg md:text-xl text-neutral-600 leading-relaxed" data-id="element-2642">
            See how fast-growing companies are deploying autonomous coworkers to
            scale their operations without scaling headcount.
          </motion.p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10" data-id="element-2643">
          {STUDIES.map((study, i) => <motion.div key={study.company} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1 * i + 0.3
        }} className="group bg-white border border-neutral-200 rounded-3xl overflow-hidden hover:shadow-xl hover:shadow-orange-900/5 transition-all cursor-pointer flex flex-col" data-id="element-2644">
              <div className="relative w-full aspect-[2/1] bg-neutral-200 overflow-hidden" data-id="element-2645">
                <img src={study.image} alt={`${study.company} team`} className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700" data-id="element-2646" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-2647" />
                <div className="absolute bottom-6 left-6 flex items-center gap-3" data-id="element-2648">
                  <div className="w-10 h-10 rounded-xl bg-white text-[#2B211A] font-title font-bold text-xl flex items-center justify-center shadow-lg" data-id="element-2649">
                    {study.logo}
                  </div>
                  <span className="text-white font-bold text-xl" data-id="element-2650">
                    {study.company}
                  </span>
                </div>
              </div>

              <div className="p-8 md:p-10 flex flex-col flex-1" data-id="element-2651">
                <div className="mb-8" data-id="element-2652">
                  <span className="text-3xl md:text-4xl font-title font-bold text-[#EA580C] block mb-2" data-id="element-2653">
                    {study.metric}
                  </span>
                  <span className="text-lg md:text-xl font-medium text-[#2B211A]" data-id="element-2654">
                    {study.result}
                  </span>
                </div>

                <p className="text-neutral-600 italic leading-relaxed mb-8 flex-1" data-id="element-2655">
                  {study.quote}
                </p>

                <div className="flex items-center gap-2 text-sm font-bold text-[#2B211A] group-hover:text-[#EA580C] transition-colors mt-auto" data-id="element-2656">
                  Read full story{' '}
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-2657" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}